module.exports = __webpack_public_path__ + "static/media/training_meditation_somatic_exercise.dc602ea7.webp";